import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../assets/css/OrderSuccess.css"; // Import normal CSS

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderDetails = location.state?.order || {};

  useEffect(() => {
    if (!orderDetails) {
      navigate("/"); // Redirect if no order data is found
    }
  }, [orderDetails, navigate]);

  return (
    <div className="order-success-container">
      <div className="order-success-box">
        <h1 className="success-title">🎉 Order Placed Successfully</h1>
        <p className="success-text">Admin will reach out to you</p>

        {orderDetails?.id && (
          <div className="order-details">
            <p><strong>Order ID:</strong> {orderDetails.id}</p>
            <p><strong>Amount Paid:</strong> ₹{(orderDetails.amount / 100).toFixed(2)}</p>
            <p><strong>Payment ID:</strong> {orderDetails.payment_id}</p>
          </div>
        )}

        <button onClick={() => navigate("/")} className="checkout-classname-apply-btn">
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default OrderSuccess;
